import React from 'react';
import {NavLink} from 'react-router-dom';
import moment from 'moment';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import {SubscribeButton} from '../../profile/components/SubscribeButton';
import {SUBSCRIPTIONS_PRICES} from '../constants';
// import checkCircle from 'images/check_circle.svg';
import listCheck from 'images/listCheck.svg';

export const TopicItem = ({
  topic,
  payments,
  handleClick,
  handleExamStripeModal,
  subscriptionOption,
  changeSubscriptionOption,
  }) => {
  const handleTopicClick = () => {
    handleClick(topic.tutorial_type);
  };
  // const filterActiveSubscription = payments.filter(payment => !payment.tutorial_title && moment(payment.start_date, 'DD/MM/YYYY').add(1, 'year').isSameOrAfter(moment()) && payment.status === 'success')[0];
  // const isActive = payments.map(payment => payment.status === 'success' && payment.tutorial_title).includes(topic.title) || (topic.tutorial_type === 'ckt' && filterActiveSubscription);
  const isActive = payments.map(payment => payment.status === 'success' && moment().isSameOrBefore(moment(payment.end_date, 'DD/MM/YYYY')))[0];
  const cost = SUBSCRIPTIONS_PRICES[subscriptionOption[topic.tutorial_type]] || 199;

  const renderPharmacist = () => {
    return (
      <div className='dashboard-options-list'>
        {/* <p className="dashboard-option-text" style={{marginLeft: 0}}>Over :</p> */}
        <div className='dashboard-option'>
          <img src={listCheck} alt="checkCircle" />
          <p className="dashboard-option-text">
            {'> 20 hours of PRE exam topics covered via video format'}
          </p>
        </div>
        <div className='dashboard-option'>
          <img src={listCheck} alt="checkCircle" />
          <p className="dashboard-option-text">
            {'> 30 OSCE scenarios'}
          </p>
        </div>
        <div className='dashboard-option'>
          <img src={listCheck} alt="checkCircle" />
          <p className="dashboard-option-text">
            {'> 100 MCQ style questions'}
            {/* <p className='dashboard-option-subtext'>, </p> */}
          </p>
        </div>
        {/* <ul> */}
          {/* <li>to help you prepare for your PRE Exam</li> */}
          {/* <li>common reasons for failing a case</li> */}
        {/* </ul> */}
        {!isActive && (
          <div className="input-wrap select-wrap" style={{ flexDirection: "column", alignItems: "center" }}>
            <SelectFieldWrapper
              // elements={[{value: 0, title: 'ANNUAL SUBSCRIPTION - € 199'}, {value: 1, title: '6 MONTH SUBSCRIPTION - € 445'}, {value: 2, title: '3 MONTH SUBSCRIPTION - € 129'}]}
              elements={[{value: 0, title: 'ANNUAL SUBSCRIPTION - € 199'}, {value: 2, title: '3 MONTH SUBSCRIPTION - € 129'}]}
              placeholder=""
              name={topic.tutorial_type}
              value={subscriptionOption[topic.tutorial_type] ? subscriptionOption[topic.tutorial_type] : 0}
              onChange={changeSubscriptionOption}
              style={{position: 'absolute'}}
              className="select"
              floatingLabelText="Choose subscription option:"
              fullWidth
            />
            <SubscribeButton topic={topic} onClick={handleExamStripeModal} title={`€ ${cost} – PURCHASE NOW`} />
          </div>
        )}
      </div>
    );
  }

  const renderOptions = (type) => {
    switch(type) {
      case 'pharmacist':
        return renderPharmacist();
      default:
        return;
    }
  }

  return (
    <div className='exam-prep-dashboard-option'>
      {/* <div className='option-top'> */}
        {/* <p className='option-title'>{`${topic.title}`}</p> */}
        {/* <div className='divider' /> */}
        {/* {!isActive && (
          <div className='price-block'>
            <p className='price'>€ 595</p>
            <p className='price-text'>for an annual subscription</p>
          </div>
        )} */}
      {/* </div> */}
      {renderOptions(topic.tutorial_type)}
      {isActive && (
        <NavLink
          className="btn-new-main"
          to={`/exam-prep/topic/${topic.id}`}
          onClick={handleTopicClick}>
            {isActive ? `Access ${topic.title}` : '€ 199 – PURCHASE NOW'}
        </NavLink>
      )}
      {/* ) : (
        <SubscribeButton topic={topic} onClick={handleExamStripeModal} title={`€ ${cost} – PURCHASE NOW`} />
      )} */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/examPrepDashboard/components/TopicItem.jsx